import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit_active",
  "use": "edit_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"edit_active\"><path d=\"m11.653 2.903-8.75 8.75a1.375 1.375 0 0 0-.403.972v3.5c0 .76.616 1.375 1.375 1.375h3.5c.365 0 .714-.145.972-.403l8.75-8.75a1.375 1.375 0 0 0 0-1.944l-3.5-3.5a1.375 1.375 0 0 0-1.944 0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol